<section>
  <onyx-information-heading [count]="contractor().contactPersons.length">
    {{ 'labels.contactPersons' | translate }}
  </onyx-information-heading>

  <onyx-information-list>
    @for (person of contractor().contactPersons; track person) {
      <onyx-information-row
        class="contact-persons"
        [label]="`${DictionaryCode.EMPLOYEE_ROLE}.${person.roles[0]}`"
      >
        <div class="contact-person">
          <p class="name">{{ person | onyxName }}</p>

          <p>{{ person.email }}</p>

          <p>{{ person.phone | onyxPhone }}</p>
        </div>

        <div class="contact-person-buttons">
          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="24"
            icon="telephone-outlined"
            (click)="ActionHelper.makeCall(person.phone)"
          ></onyx-icon-button>

          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="24"
            icon="email-outlined"
            (click)="ActionHelper.sendEmail(person.email)"
          ></onyx-icon-button>
        </div>
      </onyx-information-row>
    }
  </onyx-information-list>
</section>
